import * as action from "./actions";

export const getUserVouchers = id => {
  return {
    type: action.GET_VOUCHERS,
    payload: id
  };
};

export const setUserVouchers = vouchers => {
  return {
    type: action.SET_VOUCHERS,
    payload: vouchers
  };
};

const ACTION_HANDLERS = {
  [action.GET_VOUCHERS]: (state, action) => {
    return { ...state };
  },
  [action.SET_VOUCHERS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {
  vouchers: {
    status: 0
  }
};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
